import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, SparklesIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { heroImage } from '../data/content';
const perks = ['Instant digital download', 'Print easily at home', '30 imaginative themes', '150+ paper dolls included'];
export function Hero() {
  return <header className="relative overflow-hidden bg-cream" data-id="element-72" data-mp="4njnu5x67n8v">
      <div aria-hidden="true" className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full bg-blush-100 blur-3xl" data-id="element-73" data-mp="129qs1epkbdkp" />
      <div aria-hidden="true" className="pointer-events-none absolute -right-32 top-40 h-80 w-80 rounded-full bg-lilac-100 blur-3xl" data-id="element-74" data-mp="x8jojrugd0ju" />

      <div className="relative mx-auto grid max-w-6xl items-center gap-10 px-5 py-12 md:grid-cols-2 md:gap-12 md:py-20" data-id="element-75" data-mp="nbeyhgxhkkxr">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-76" data-mp="3d2tm12xxw8bd">
          <p className="inline-flex items-center gap-2 rounded-full bg-lilac-100 px-4 py-1.5 text-xs font-bold uppercase tracking-wide text-lilac-500 sm:text-sm" data-id="element-77" data-mp="3j9u2j3pddwnx">
            <SparklesIcon className="h-4 w-4" aria-hidden="true" data-id="element-78" data-mp="39al8kaui8i1k" />
            For girls ages 4–10 · Creative screen-free fun
          </p>

          <h1 className="mt-5 font-display text-4xl font-extrabold leading-[1.1] text-ink sm:text-5xl lg:text-6xl" data-id="element-79" data-mp="3e84rho25dizu">
            Turn screen-time battles into{' '}
            <span className="text-blush-500" data-id="element-80" data-mp="3599ik47pxusu">magical playtime.</span>
          </h1>

          <p className="mt-5 max-w-xl text-lg leading-relaxed text-ink/80" data-id="element-81" data-mp="2qjv4iit76p74">
            150+ printable paper dolls spread across 30 enchanting themes — outfits,
            accessories, rooms and story elements she can mix, match and enjoy over and over.
          </p>

          <div className="mt-7 flex flex-col items-start gap-3 sm:flex-row sm:items-center" data-id="element-82" data-mp="2hjym2yxeimki">
            <CtaButton data-id="element-83" data-mp="2ljz1alsbr1sm">Get instant access!</CtaButton>
            <span className="font-display text-lg font-bold text-blush-500" data-id="element-84" data-mp="s2jj7lrcvge8">$27</span>
            <span className="text-sm text-ink/60 line-through" data-id="element-85" data-mp="nbl3ooe6ymc1">$85 value</span>
          </div>

          <ul className="mt-7 grid gap-2 sm:grid-cols-2" data-id="element-86" data-mp="ibyqgeyd5638">
            {perks.map(perk => <li key={perk} className="flex items-center gap-2 text-sm font-semibold text-ink/80" data-id="element-87" data-mp="dd59gcjvawyb">
                <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-mint-100 text-mint-500" data-id="element-88" data-mp="1b0njrrt6g74f">
                  <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-89" data-mp="161jbr4hzoffo" />
                </span>
                {perk}
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        ease: 'easeOut',
        delay: 0.1
      }} className="relative" data-id="element-90" data-mp="x1nwanhehy9u">
          <div className="overflow-hidden rounded-4xl border-4 border-white bg-white shadow-card" data-id="element-91" data-mp="3hqka8g5ttosb">
            <img src={heroImage} alt="The complete My Magical World of Paper kit: printable paper dolls, outfits, room scenes, bonus collections and the digital files shown on a laptop" className="h-full w-full object-cover" loading="eager" data-id="element-92" data-mp="1xam6ou2m9x0i" />
          </div>
          <div className="absolute -bottom-4 left-4 rotate-[-3deg] rounded-2xl bg-sun-300 px-4 py-2 font-display text-sm font-bold text-ink shadow-soft sm:text-base" data-id="element-93" data-mp="2b20tlbznaicu">
            30 enchanting themes 🎀
          </div>
        </motion.div>
      </div>
    </header>;
}